module.exports = __webpack_public_path__ + "static/media/ade-rs-competition.47d78d7c.jpeg";